// extracted by mini-css-extract-plugin
export default {"filtersContainer":"FilterCalendar_filtersContainer__OxdOm","filterOpened":"FilterCalendar_filterOpened__bbYSS","filterClosed":"FilterCalendar_filterClosed__hjVZF"};